import { render, staticRenderFns } from "./ICP.vue?vue&type=template&id=1af4866a&scoped=true"
import script from "./ICP.vue?vue&type=script&lang=js"
export * from "./ICP.vue?vue&type=script&lang=js"
import style0 from "./ICP.vue?vue&type=style&index=0&id=1af4866a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1af4866a",
  null
  
)

export default component.exports